import React, { useState, useEffect, forwardRef, useRef } from "react";
import { Tabs, Descriptions, Tag, Image, Divider } from "antd";
import LaboratorySheet from "./LaboratorySheet";
import QuestionSheet from "./QuestionSheet";
import { Container, Row, Col } from "react-bootstrap";
import DisplayFile from "./DisplayFile";
import Certificate from "./Certificate";
import DisplayMultiplePage from "./DisplayMultiplePage";
import MedicalReport from "./MedicalReport";
import Common from "./includes/Common";
import { Parser } from 'html-to-react';
import Moment from "react-moment";
import VaccinView from "./VaccinView";
import MedFormVa from "./forms/MedFormVa";
import MedFormPe from "./forms/MedFormPe";
import MedFormJour from "./forms/MedFormJour";
import MedFormFhVa from "./forms/MedFormFhVa";
import MedFormFhPe from "./forms/MedFormFhPe";
import MedFormVaEn from "./forms/MedFormVaEn";
import MedFormPeEn from "./forms/MedFormPeEn";
import SignConsent from "./SignConsent";
import MedForm from "./forms/MedForm";
import MedFormEn from "./forms/MedFormEn";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var OneFileRecord = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var candidat = _ref.candidat;
  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    id: "printable",
    children: [(candidat.link == null || candidat.link == "null" || candidat.link.length == 0) && /*#__PURE__*/_jsxs(_Fragment, {
      children: [candidat.medecine_questions && candidat.medecine_questions.file != null && candidat.medecine_questions.file != "null" && candidat.medecine_questions.file != "NULL" && candidat.medecine_questions.file != "Null" && /*#__PURE__*/_jsx(DisplayMultiplePage, {
        pageCount: 12,
        file_url: candidat.medecine_questions.file
      }), candidat.medecine_questions != null && candidat.medecine_questions.file == null && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(SignConsent, {
          candidat: candidat,
          ro: true,
          set_sign: function set_sign() {}
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), candidat.nationality.toLowerCase().indexOf("guin") > -1 && candidat.nationality.split(" ").length == 1 ? /*#__PURE__*/_jsx(MedForm, {
          readOnly: 1,
          formType: 11,
          candidat: candidat,
          handler: function handler() {
            setDataChanged(true);
            setShowNewForm(false);
            notification.success({
              message: "Ok!",
              description: "Les donnés ont été sauvegardées"
            });
          }
        }) : /*#__PURE__*/_jsx(MedFormEn, {
          readOnly: 1,
          formType: 41,
          candidat: candidat,
          handler: function handler() {
            setDataChanged(true);
            setShowNewForm(false);
            notification.success({
              message: "Ok!",
              description: "Les donnés ont été sauvegardées"
            });
          }
        })]
      })]
    }), /*#__PURE__*/_jsx("br", {}), candidat.conclusion && /*#__PURE__*/_jsx(DisplayMultiplePage, {
      pageCount: 1,
      file_url: candidat.conclusion.file
    }), /*#__PURE__*/_jsx("br", {}), candidat.id_file && /*#__PURE__*/_jsx(DisplayMultiplePage, {
      pageCount: 1,
      file_url: candidat.id_file
    }), /*#__PURE__*/_jsx("br", {}), candidat && /*#__PURE__*/_jsx(LaboratorySheet, {
      candidat: candidat
    }), /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              padding: "12px",
              background: "#E1E0DF",
              borderRadius: "3px"
            },
            children: [/*#__PURE__*/_jsx("h6", {
              className: "light",
              children: /*#__PURE__*/_jsx("b", {
                children: "RESULTATS DE VISIO TEST"
              })
            }), /*#__PURE__*/_jsx(Descriptions, {
              column: 2,
              items: [{
                key: 1,
                label: /*#__PURE__*/_jsx("b", {
                  children: "Binoculaire"
                }),
                children: /*#__PURE__*/_jsx(_Fragment, {
                  children: candidat.visio_test && /*#__PURE__*/_jsx("span", {
                    children: candidat.visio_test.binocular
                  })
                })
              }, {
                key: 2,
                label: /*#__PURE__*/_jsx("b", {
                  children: "Oeil Gauche"
                }),
                children: /*#__PURE__*/_jsx(_Fragment, {
                  children: candidat.visio_test && /*#__PURE__*/_jsx("span", {
                    children: candidat.visio_test.leftsight
                  })
                })
              }, {
                key: 3,
                label: /*#__PURE__*/_jsx("b", {
                  children: "Oeil droit"
                }),
                children: /*#__PURE__*/_jsx(_Fragment, {
                  children: candidat.visio_test && /*#__PURE__*/_jsx("span", {
                    children: candidat.visio_test.rightsight
                  })
                })
              }, {
                key: 4,
                label: /*#__PURE__*/_jsx("b", {
                  children: "VISION DES COULEURS"
                }),
                children: /*#__PURE__*/_jsx(_Fragment, {
                  children: candidat.visio_test && (candidat.visio_test.colorseeing == 0 ? /*#__PURE__*/_jsx(Tag, {
                    color: "#f50",
                    children: "NON VALIDE"
                  }) : /*#__PURE__*/_jsx(Tag, {
                    color: "#699C4E",
                    children: "VALIDE"
                  }))
                })
              }, {
                key: 5,
                label: /*#__PURE__*/_jsx("b", {
                  children: "TESTE D'EBLOUISSEMENT"
                }),
                children: /*#__PURE__*/_jsx(_Fragment, {
                  children: candidat.visio_test && (candidat.visio_test.blowtest == 0 ? /*#__PURE__*/_jsx(Tag, {
                    color: "#f50",
                    children: "NON VALIDE"
                  }) : /*#__PURE__*/_jsx(Tag, {
                    color: "#699C4E",
                    children: "VALIDE"
                  }))
                })
              }, {
                key: 6,
                label: /*#__PURE__*/_jsx("b", {
                  children: "CHAMPS PERIPHERIQUES"
                }),
                children: /*#__PURE__*/_jsx(_Fragment, {
                  children: candidat.visio_test && (candidat.visio_test.peripheral == 0 ? /*#__PURE__*/_jsx(Tag, {
                    color: "#f50",
                    children: "NON VALIDE"
                  }) : /*#__PURE__*/_jsx(Tag, {
                    color: "#699C4E",
                    children: "VALIDE"
                  }))
                })
              }, {
                key: 7,
                label: /*#__PURE__*/_jsx("b", {
                  children: "CONCLUSION"
                }),
                children: /*#__PURE__*/_jsx(_Fragment, {
                  children: candidat.visio_test && /*#__PURE__*/_jsx("span", {
                    children: candidat.visio_test.comment
                  })
                })
              }]
            }), /*#__PURE__*/_jsx("br", {}), candidat.visio_test && /*#__PURE__*/_jsx(DisplayMultiplePage, {
              pageCount: 1,
              file_url: candidat.visio_test.attached_file
            })]
          })
        })
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              padding: "12px",
              background: "#DEE1DC",
              borderRadius: "3px"
            },
            children: [/*#__PURE__*/_jsx("h6", {
              className: "light",
              children: /*#__PURE__*/_jsx("b", {
                children: "RESULTATS AUDIO TEST"
              })
            }), candidat.audio_test && /*#__PURE__*/_jsx(DisplayMultiplePage, {
              pageCount: 1,
              file_url: candidat.audio_test.attached_file
            })]
          })
        })
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              padding: "12px",
              background: "#E1DCE1",
              borderRadius: "3px"
            },
            children: [/*#__PURE__*/_jsx("h4", {
              className: "light",
              children: /*#__PURE__*/_jsx("b", {
                children: "RESULTATS DE SPIROMETRIE"
              })
            }), candidat.spirometrie && (candidat.spirometrie.status == 0 ? /*#__PURE__*/_jsx(Tag, {
              color: "#f50",
              children: "NON VALIDE"
            }) : /*#__PURE__*/_jsx(Tag, {
              color: "#699C4E",
              children: "VALIDE"
            })), /*#__PURE__*/_jsx("h6", {
              className: "light",
              children: /*#__PURE__*/_jsx("b", {
                children: "COMMENTAIRE"
              })
            }), candidat.spirometrie && candidat.spirometrie.comment != null && candidat.spirometrie.comment.length > 0 && /*#__PURE__*/_jsx("p", {
              children: candidat.spirometrie.comment
            }), candidat.spirometrie && candidat.spirometrie.comment != null && (candidat.spirometrie.comment == null || candidat.spirometrie.comment.length == 0 || candidat.spirometrie.comment == 'undefined') && /*#__PURE__*/_jsx("p", {
              children: "Aucun commentaire"
            }), candidat.spirometrie && /*#__PURE__*/_jsx(DisplayMultiplePage, {
              pageCount: 2,
              file_url: candidat.spirometrie.file
            })]
          })
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              padding: "12px",
              background: "#DCE1DE",
              borderRadius: "3px"
            },
            children: [/*#__PURE__*/_jsx("h4", {
              className: "light",
              children: /*#__PURE__*/_jsx("b", {
                children: "RESULTATS D'ELECTRO-CARDIOGRAMME"
              })
            }), candidat.ecg && /*#__PURE__*/_jsx(DisplayMultiplePage, {
              pageCount: 2,
              file_url: candidat.ecg.file
            }), /*#__PURE__*/_jsx("h6", {
              className: "light",
              children: /*#__PURE__*/_jsx("b", {
                children: "COMMENTAIRE"
              })
            }), candidat.ecg && candidat.ecg.comment != null && candidat.ecg.comment.length > 0 && /*#__PURE__*/_jsx("p", {
              children: Parser().parse(candidat.ecg.comment)
            }), candidat.ecg && candidat.ecg.comment != null && (candidat.ecg.comment == null || candidat.ecg.comment.length == 0 || candidat.ecg.comment == 'undefined') && /*#__PURE__*/_jsx("p", {
              children: "Aucun commentaire"
            })]
          })
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h4", {
        className: "light",
        children: /*#__PURE__*/_jsx("b", {
          children: "RADIOGRAPHIE"
        })
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsxs("div", {
            className: "infoBox",
            style: {
              minHeight: "190px",
              background: "#E6CFC0"
            },
            children: [/*#__PURE__*/_jsx("h5", {
              className: "light",
              children: /*#__PURE__*/_jsx("b", {
                children: "RESULTAT"
              })
            }), /*#__PURE__*/_jsx("div", {
              style: {
                padding: "8px"
              },
              children: candidat.im_result && candidat.im_result.result != null && candidat.im_result.result != "" && candidat.im_result.result != "undefined" ? Parser().parse(candidat.im_result.result) : "NA"
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsxs("div", {
            className: "infoBox",
            style: {
              minHeight: "190px",
              background: "#CDDFE6"
            },
            children: [/*#__PURE__*/_jsx("h5", {
              className: "light",
              children: /*#__PURE__*/_jsx("b", {
                children: "CONCLUSION"
              })
            }), /*#__PURE__*/_jsx("div", {
              style: {
                padding: "8px"
              },
              children: candidat.im_result && candidat.im_result.conclusion != null && candidat.im_result.conclusion != "" && candidat.im_result.conclusion != "undefined" ? Parser().parse(candidat.im_result.conclusion) : "NA"
            })]
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [candidat.im_result && candidat.im_result.image_file && /*#__PURE__*/_jsx(Image, {
            className: "framed",
            src: Common.baseUrl + candidat.im_result.image_file,
            preview: false,
            width: "100%"
          }), candidat.im_result && candidat.im_result.attached_file && /*#__PURE__*/_jsx(DisplayMultiplePage, {
            pageCount: 1,
            file_url: candidat.im_result.attached_file
          })]
        })
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx("div", {})
        })
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsx("h4", {
            className: "light",
            children: /*#__PURE__*/_jsx("b", {
              children: "VACCINATION"
            })
          }), candidat.vaccin_process && candidat.vaccin_process.attached_file && /*#__PURE__*/_jsx(DisplayMultiplePage, {
            pageCount: 2,
            file_url: candidat.vaccin_process.attached_file
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(VaccinView, {
              vaccin_process: candidat.vaccin_process
            })
          }), /*#__PURE__*/_jsx(Divider, {})]
        })
      }), candidat.conclusion && /*#__PURE__*/_jsx(MedicalReport, {
        ref: ref,
        candidat: candidat
      })]
    })]
  });
});
export default OneFileRecord;